export default __webpack_public_path__ + "static/media/cuposExample.4e66a713.svg";